<button
  id="user-menu-button"
  aria-expanded="false"
  data-dropdown-toggle="user-dropdown"
  data-dropdown-placement="bottom"
  class="border border-accent p-0.5 font-medium text-secondary rounded-full hover:text-primary focus:ring-4 focus:ring-gray-100"
  type="button"
>
  <span class="sr-only">Open user menu</span>
  <div class="flex items-center" *ngIf="profile && profile.username">
    <div
      class="relative inline-flex items-center justify-center w-9 h-9 overflow-hidden bg-accent rounded-full"
    >
      <span class="font-medium text-white">{{
        profile.username[0].toUpperCase()
      }}</span>
    </div>
    <span class="ml-2 max-sm:hidden" [class.mr-2]="isRTL">{{
      profile.username
    }}</span>
    <i class="fa-solid fa-caret-down mx-2"></i>
  </div>
</button>

<div
  id="user-dropdown"
  class="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow w-40"
>
  <div class="px-4 py-3 text-sm text-secondary">
    <div class="font-medium">
      {{ profile?.firstName }} {{ profile?.lastName }}
    </div>
    <div class="truncate">{{ profile?.email }}</div>
  </div>
  <ul class="py-2 text-sm text-gray-700" aria-labelledby="user-menu-button">
    <li>
      <a
        routerLink="/profile/my-profile"
        class="block px-4 py-2 hover:bg-gray-100"
      >
        <i class="fa-regular fa-user" [ngClass]="isRTL ? 'ml-2' : 'mr-2'"></i
        >{{ "APP_USER.PROFILE" | translate }}</a
      >
    </li>
    <li>
      <a
        (click)="signout()"
        class="cursor-pointer block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white"
      >
        <i
          class="fa-solid fa-arrow-right-from-bracket"
          [ngClass]="isRTL ? 'ml-2' : 'mr-2'"
        ></i
        >{{ "APP_USER.LOGOUT" | translate }}</a
      >
    </li>
  </ul>
</div>
